import { z } from "zod";

// isolatedDeclarations: define output shape as TS interface, annotate
// Zod const with z.ZodType<Interface> so tsc can emit declarations without
// reading across module boundaries (D-15 paranoid-strict tsconfig).
//
// exactOptionalPropertyTypes: optional `charter` field typed as
// `string | undefined` to match ZodOptional's output type.

// ModeDefinition — a recipe-declared mode with a bounded id, name, and optional charter.
// Modes are recipe-declared (D-13); mode precondition evaluation is evaluator-side (Phase 9, D-14).
// The `id` field is constrained to kebab-case per REVIEWS Suggestion #12 (MEDIUM),
// matching the pattern applied by widget-template.ts (Plan 02), option-category.ts (Plan 03),
// and slot-id.ts's AUTHOR_SLOT_RE.
export interface ModeDefinition {
  id: string;
  name: string;
  charter?: string | undefined;
}

export const ModeDefinition: z.ZodType<ModeDefinition> = z.strictObject({
  // REVIEWS Suggestion #12: kebab-case regex on id — same pattern as AUTHOR_SLOT_RE
  // in slot-id.ts and widget-template.ts (Plan 02). Message must contain "kebab-case".
  id: z
    .string()
    .min(1)
    .max(50)
    .regex(/^[a-z][a-z0-9-]*$/, "kebab-case"),
  name: z.string().min(1).max(100),
  charter: z.string().min(1).max(500).optional(),
});
